import { render, staticRenderFns } from "./ItemCommonDescription.vue?vue&type=template&id=3dc40340&scoped=true&"
import script from "./ItemCommonDescription.vue?vue&type=script&lang=js&"
export * from "./ItemCommonDescription.vue?vue&type=script&lang=js&"
import style0 from "./ItemCommonDescription.vue?vue&type=style&index=0&id=3dc40340&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc40340",
  null
  
)

export default component.exports